export const issueTerm = 'work item';
export const initiativeTerm = 'initiative';
export const feedbackTerm = 'feedback';
export const assigneeTerm = 'member';
export const documentTerm = 'document';
export const releaseTerm = 'release';
export const assignVerb = 'Change members';
export const selfAssignVerb = `add yourself`;
